// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; 
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

// NOTE: Ensure these values are correct for your project
const firebaseConfig = {
  apiKey: "AIzaSyArk9CW8D64_r7wZRDfgzzlDWoxkINmxV4",
  authDomain: "asidorsmusic.firebaseapp.com",
  databaseURL: "https://asidorsmusic-default-rtdb.firebaseio.com",
  projectId: "asidorsmusic",
  storageBucket: "asidorsmusic.firebasestorage.app",
  messagingSenderId: "944563196890",
  appId: "1:944563196890:web:2c647a53ed60245ffc26e3",
  measurementId: "G-JC8G6VHGDE"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);

// **Export Google Auth Provider**
export const googleProvider = new GoogleAuthProvider();

// Optional: Configure to prompt account selection every time
googleProvider.setCustomParameters({
  prompt: 'select_account'
});